import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import socialConstructor from 'utils/socialUrlConstructor';
import {
  MenuShareStyled,
  TitleWrapper,
  StyledTitle,
  ShareItemStyled,
  ShareTextStyled,
} from '../styled/MenuStyled';

const socialParams = {
  fb: {
    iconName: 'mob_f',
    name: 'Facebook',
  },
  twitter: {
    iconName: 'mob_t',
    name: 'Twitter',
  },
  tg: {
    iconName: 'mob_tg',
    name: 'Telegram',
  },
  vb: {
    iconName: 'mob_viber',
    name: 'Viber',
  },
};

function getClickListener(social, shareLink) {
  return () => window.open(socialConstructor(social, shareLink, ''));
}

function renderShareButton(socials, shareLink) {
  return socials.map((socialName) => {
    const soc = socialParams[socialName];
    return soc ? (
      <ShareItemStyled
        key={socialName}
        onClick={getClickListener(socialName, shareLink)}
      >
        <Icon name={soc.iconName} size={32} fillColor="inherit" />
        <ShareTextStyled size="fs_s" font="inherit" weight="600" color="black">
          {soc.name}
        </ShareTextStyled>
      </ShareItemStyled>
    ) : undefined;
  });
}

function MenuShare({ socials, shareLink, titleText }) {
  return (
    <MenuShareStyled>
      <TitleWrapper>
        <StyledTitle
          fixedSize
          color="gray_cod"
          size="fs_xs"
          font="inherit"
          weight="700"
        >
          {titleText.toUpperCase()}
        </StyledTitle>
      </TitleWrapper>
      {renderShareButton(socials, shareLink, titleText)}
    </MenuShareStyled>
  );
}

MenuShare.propTypes = {
  shareLink: PropTypes.string.isRequired,
  socials: PropTypes.array.isRequired,
  titleText: PropTypes.string.isRequired,
};

export default memo(MenuShare);
